export default "__VITE_ASSET__CwaWKcfV__"